import { makeAutoObservable } from "mobx";

// Filters shared by the Overview page in both flat and consolidated modes.
// Single source of truth — toggling consolidated preserves selections.
const createFilters = () => ({
  year: "", // "" means "All Years"; otherwise a single year string
  framework: "",
  category: "",
  metricType: "",
  search: "",
  orgIds: [], // multi-select; empty = all orgs
});

class DataEntryFiltersStore {
  filters = createFilters();

  constructor() {
    makeAutoObservable(this);
  }

  get activeCount() {
    const f = this.filters;
    let n = 0;
    if (f.year) n++;
    if (f.framework) n++;
    if (f.category) n++;
    if (f.metricType) n++;
    if (f.search) n++;
    if (f.orgIds?.length) n++;
    return n;
  }

  setFilters = (patch) => {
    this.filters = { ...this.filters, ...patch };
  };

  reset = () => {
    this.filters = createFilters();
  };
}

export const dataEntryFiltersStore = new DataEntryFiltersStore();
